import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { TokenService } from '../shared/services/token.service';
import { UserService } from '../shared/services/user.service';
import { AppConfigService } from '../shared/services/app-config.service';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
})
export class AuthComponent implements OnInit, OnDestroy {
  unsubscribe = new Subject<void>();
  userData: any;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private tokenService: TokenService,
    private userDetails: UserService,
    public appConfig: AppConfigService
  ) { }

  ngOnInit(): void {
    this.activatedRoute.queryParams
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(async params => {
        if (params?.['token']) {
         localStorage.setItem('token', params['token']); 
         const data = this.userDetails.decodeToken(params['token']);
         this.getUserDetails(+data['nameid']);
         await this.appConfig.loadCompanyConfiguration();
          this.router.navigate(['/']);
        }
      });
  }
  getUserDetails(userId: any) {
    this.userDetails.GetUserDetails(userId).subscribe((response: any) => {
      this.userData = response.data;
      console.log(this.userData);
      localStorage.setItem('fullName', this.userData.fullName);
      localStorage.setItem('city', this.userData.city);
      localStorage.setItem('userid', this.userData.userId);
      localStorage.setItem('role', JSON.stringify(this.userData.role));
      localStorage.setItem('branch', JSON.stringify(this.userData.branch));
      localStorage.setItem('maxAllowedLineDiscount', this.userData?.maxAllowedLineDiscount);
      localStorage.setItem('maxAllowedInvoiceDiscount', this.userData?.maxAllowedInvoiceDiscount);
      localStorage.setItem('canEditUnitPrice', this.userData?.canEditUnitPrice);
    })
  }
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
